import CircleProfessional from '../../src/legacy/CircleProfessional';
export default CircleProfessional;
